<template lang="pug">
footer.py-5.bg-dark
  .container
    .sns-links
      .sns-link
        a(href="https://www.facebook.com/topbasketballcamp", target="_blank")
          font-awesome-icon(:icon="['fab', 'facebook-square']")
      .sns-link
        a(href="https://line.me/R/ti/p/%40topbasketball", target="_blank")
          font-awesome-icon(:icon="['fab', 'line']")
      .sns-link
        a(href="https://www.instagram.com/topbasketballcamp/", target="_blank")
          font-awesome-icon(:icon="['fab', 'instagram']") 
    p.m-0.mt-4.text-center.text-white.contact 聯絡電話 : {{ profile.phone }}
    p.m-0.text-center.text-white.contact 聯絡時間 : {{ profile.contact_time }}
    p.m-0.mt-4.text-center.text-white.copyright Copyright &copy; TOP巔峰籃球訓練營 2020
</template>

<script>
import { getCompanyProfile } from "@/api/web_content";

export default {
  name: "Footer",
  data() {
    return {
      profile: {
        address: "",
        description: "",
        email: "",
        phone: "",
        contacts: [],
        contact_time: "",
      },
    };
  },
  created() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      getCompanyProfile().then((response) => {
        this.profile = response.data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.sns-links {
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}

.sns-link {
  font-size: 24px;
  margin-left: 10px;
  margin-right: 10px;

  a {
    color: $color_blue;
  }
}

.contact {
  font-weight: 300;
  font-size: 14px;
}

.copyright {
  font-size: 14px;
}

.bg-dark {
  background: $c-text !important;
}
</style>
